export const BUCK_EVENTS = {
  AUTH_METHOD_SELECTED: 'buck_auth_method_selected',
  CONTACT_LANDOWNER_DISPLAYED: 'buck_contact_landowner_displayed',
  LT_PLUS_AUTH_SUCCESS: 'buck_lt_plus_auth_success',
  LT_PLUS_CHECKOUT_BACK_CLICKED: 'buck_lt_plus_checkout_back_clicked',
  LT_PLUS_CHECKOUT_ERROR: 'buck_lt_plus_checkout_error',
  LT_PLUS_CHECKOUT_STARTED: 'buck_lt_plus_checkout_started',
  LT_PLUS_CHECKOUT_SUCCESS: 'buck_lt_plus_checkout_success',
  LT_PLUS_CONFIRMATION_DONE_CLICKED: 'buck_lt_plus_confirmation_done_clicked',
  LT_PLUS_CTA_CLICKED: 'buck_lt_plus_cta_clicked',
  LT_PLUS_CTA_DISPLAYED: 'buck_lt_plus_cta_displayed',
  LT_PLUS_DRAWER_CLOSED: 'buck_lt_plus_drawer_closed',
  LT_PLUS_DRAWER_OPENED: 'buck_lt_plus_drawer_opened',
  LT_PLUS_EXISTING_MEMBER_CTA_CLICKED: 'buck_lt_plus_existing_member_cta_clicked',
  LT_PLUS_FLOW_COMPLETED: 'buck_lt_plus_flow_completed',
  LT_PLUS_PAYWALL_VIEWED: 'buck_lt_plus_paywall_viewed',
  LT_PLUS_SIGN_IN_CLICKED: 'buck_lt_plus_sign_in_clicked',
  OTP_CODE_RESENT: 'buck_otp_code_resent',
  OTP_CODE_SENT: 'buck_otp_code_sent',
  OTP_CODE_VERIFIED: 'buck_otp_code_verified',
  OTP_ERROR: 'buck_otp_error',
  PACKAGE_CARD_CLICKED: 'buck_package_card_clicked',
  SIGNUP_ABANDONED: 'buck_signup_abandoned',
  SIGNUP_COMPLETED: 'buck_signup_completed',
  SIGNUP_DRAWER_OPENED: 'buck_signup_drawer_opened',
} as const;

export const ANALYTICS_KEYS = {
  BILLING_INTERVAL: 'billing_interval',
  ERROR_MESSAGE: 'error_message',
  ERROR_TYPE: 'error_type',
  HAD_MEMBERSHIP: 'had_membership',
  HAS_MEMBERSHIP: 'has_membership',
  IS_AUTHENTICATED: 'is_authenticated',
  LISTING_ID: 'listing_id',
  MESSAGE_ID: 'message_id',
  METHOD: 'method',
  PACKAGE_ID: 'package_id',
  PACKAGE_URL: 'package_url',
  STEP: 'step',
  USER_TYPE: 'user_type',
  VARIANT: 'variant',
  WAS_AUTHENTICATED: 'was_authenticated',
} as const;
